import React from 'react';
import PropTypes from 'prop-types';
import helpers from '../../utils/helpers';
import StoreIcon from '../../components/StoreIcon';

const PublisherHeader = ({ data }) => {
  const { name, url, store } = data;
  return (
    <a href={url} className="breadcrumb-name text-truncate">
      {store !== 'both' && (<div className="text-black" ><StoreIcon store={store} /></div>)}
      {store === 'both' && <div className="hicon-publisher text-16" />}
      <span className="text-truncate pl-xxxs ml-xxxs">{helpers.decodeEntities(name || '')}</span>
    </a>
  );
};

PublisherHeader.propTypes = {
  data: PropTypes.object.isRequired,
};

export default PublisherHeader;
